module.exports = {
    cawiProxy: true,
    restartKeyword: 'RESTART'
}
